import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const LinkTargetsContext = createContext({ targets: [] });

export const LinkTargetsProvider = ({ children }) => {
  const [targets, setTargets] = useState([]);

  useEffect(() => {
    api.get("/articles/titles").then(({ data }) => setTargets(data || [])).catch(() => {});
  }, []);

  return (
    <LinkTargetsContext.Provider value={{ targets }}>
      {children}
    </LinkTargetsContext.Provider>
  );
};

export const useLinkTargets = () => useContext(LinkTargetsContext);
